import React, { Fragment, useEffect, useRef, useState } from 'react'
import AddComponent from '../../../components/AddComponent'
import {PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid'
import LinkButton from '../../helpers/LinkButton'
import Table from '../../helpers/Table'
import Loader from '../../Common/Loader'
import { Link } from 'react-router-dom'
import ActionButton from '../../helpers/ActionButton'
import { useReactToPrint } from 'react-to-print'
import Pagination from '../../helpers/Pagination';
import { AddCircle } from 'iconsax-react'
import DataNotFound from '../../helpers/DataNotFound'
import { DeleteGAAProductOutputDriverChannelDeviceType, GetGAAProductOutputDriverChannelDeviceTypeList } from '../../../Encapsulation/GladianceDomainEntities/GAAProductOutputDriverChannelDeviceType'
import flasher from '@flasher/flasher'
import Swal from 'sweetalert2'

function GAAProductOutputDriverChannelDeviceType() {

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }
    document.title = 'Gladiance - Product Output Channel Device Types'
    const tableHeading = ['Sr.No', 'Singular Name','Display Order','Plural Name', 'Action']
    const [loader, setLoader] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 7;
    const [errors, setErrors] = useState([])
    const [ProductOutputDriverChannelDeviceTypesList, setProductOutputDriverChannelDeviceTypes] = useState([]);
    console.log('ProductOutputDriverChannelDeviceTypesList :', ProductOutputDriverChannelDeviceTypesList);

    const fetchProductOutputDriverChannelDeviceTypesList = async () => {
        setProductOutputDriverChannelDeviceTypes(await GetGAAProductOutputDriverChannelDeviceTypeList(setErrors));
    }

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const deleteProductOutputDriverChannelDeviceType = (tableData) => {
        Swal.fire({
            title: 'Are you sure to delete this?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                let response = await DeleteGAAProductOutputDriverChannelDeviceType(tableData)
                if (response.Successful == false) {
                    flasher.warning(response.Message)
                } else {
                    flasher.success('Deleted Successfully')
                    fetchProductOutputDriverChannelDeviceTypesList();
                }
            }
        })
    }

    useEffect(() => {
        fetchProductOutputDriverChannelDeviceTypesList();
    }, [])

    return (
        <Fragment>
            {loader ? (<Loader />) : (
                <AddComponent title={'Product Output Channel Device Types'} button={
                    <LinkButton to={'/product-input-driver-channel-device-type-master/add-product-input-driver-channel-device-type-master'}>
                        <AddCircle variant='Bold' className='w-5 h-5' />
                        <span>Add Product Output Channel Device type</span>
                    </LinkButton>
                }>
                    {ProductOutputDriverChannelDeviceTypesList && ProductOutputDriverChannelDeviceTypesList.length > 0 ? (
                        <div ref={componentRef} className='m-2'>
                            <Table tableHeading={tableHeading}>
                                {ProductOutputDriverChannelDeviceTypesList && ProductOutputDriverChannelDeviceTypesList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((tableData, tableDataID) => {
                                    return (
                                        <Fragment key={tableDataID}>
                                            <tr className="border-b border-opacity-30 border-white">
                                                <td className="px-4 py-3">{tableDataID + 1}</td>
                                                <td className="px-4 py-3">{tableData.SingularName}</td>
                                                <td className="px-4 py-3">{tableData.DisplayOrder}</td>
                                                <td className="px-4 py-3">{tableData.PluralName}</td>
                                                <td className="px-4 py-3">
                                                    <div className='flex justify-center gap-3'>
                                                        <Link to={`/product-input-driver-channel-device-type-master/edit-product-input-driver-channel-device-type-master/${tableData.Ref}`} title='Edit' ><ActionButton className={'p-1.5 text-white bg-yellow-400 '}>
                                                            <PencilSquareIcon className='w-4 h-4' />
                                                        </ActionButton></Link>
                                                        <ActionButton onClick={() => deleteProductOutputDriverChannelDeviceType(tableData)} title={'Delete'} className='p-1.5 text-white bg-red-600 rounded-lg cursor-pointer'>
                                                            <TrashIcon className='w-4 h-4' />
                                                        </ActionButton>
                                                    </div>
                                                </td>
                                            </tr>
                                        </Fragment>
                                    )
                                })}
                            </Table>
                        </div>

                    ) : (
                        <DataNotFound labelText={'Sorry! Product Output Channel Device Data Not Found'} />
                    )}
                    {ProductOutputDriverChannelDeviceTypesList && ProductOutputDriverChannelDeviceTypesList.length > 7 ? (<div className="flex justify-end">
                        <Pagination
                            itemsPerPage={itemsPerPage}
                            totalItems={ProductOutputDriverChannelDeviceTypesList.length}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        />
                    </div>) : (<div></div>)
                    }
                </AddComponent>
            )}
        </Fragment>
    )
}
export default GAAProductOutputDriverChannelDeviceType
